/**
 * SOLID Review
 * S — Strong. One concern: mint the request context every client port call carries first.
 * O — Strong. A new context field is one line.
 * L — N/A — functions.
 * I — Strong. One function.
 * D — Strong. The context's type only; the clock is the browser's.
 */
import type { IContextRequest } from '../../application/ports/IContextRequest';

/** How long a use case may run before the kernel refuses a late call: generous, for two server reads. */
const USE_CASE_BUDGET_MS = 30_000;

let minted = 0;

/**
 * A FRESH CONTEXT PER USE-CASE CALL (frontend strict-ports plan, FE1e, 2026-10-03) — the client twin of
 * the backend's `RequestContexts`. The id is unique within the tab (a time prefix and a counter); the
 * deadline is absolute, so a hop that adds latency cannot restart it (`IPayloadCallContext`). The id is
 * not sent to the server yet: joining client and server traces is deferred (plan, "Deferred").
 */
export function clientContext(now: number = Date.now(), budgetMs: number = USE_CASE_BUDGET_MS): IContextRequest {
  minted += 1;
  return { requestId: `client-${now.toString(36)}-${minted}`, deadlineAt: now + budgetMs };
}
